<div class="donut-chart-widget">
   <div class="card">
     <div class="card-header">
       <h5>{{ 'Stock Market' | translate }}</h5>
     </div>
     <div class="card-body">
       <div id="chart-widget13">
         <apx-chart [series]="stockMarket.series" [plotOptions]="stockMarket.plotOptions" [legend]="stockMarket.legend" [fill]="stockMarket.fill" [chart]="stockMarket.chart" [stroke]="stockMarket.stroke" [tooltip]="stockMarket.tooltip" [xaxis]="stockMarket.xaxis" [grid]="stockMarket.grid" [responsive]="stockMarket.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>